

import React, { Component } from "react";
import {Icon, Rate, Button, Row, Col, Badge} from 'antd';
import {  Button as SVAButton } from 'antd';
import AmbItnSVPriceListView from './AmbItnSVPriceListView'
import AmbLocationSVPriceListView from './AmbLocationSVPriceListView'
import { Collapse } from 'antd';
import { Steps, Divider } from 'antd';
import {
    browserHistory as history
  } from 'react-router'
import { flySaveMcitytReviewSuccess } from "../../redux/svractions/svflysearchActions";

const { Step } = Steps;




const {Link} = require("react-router")
const { Panel } = Collapse;
const text = `
  A dog is a type of domesticated animal.
  Known for its loyalty and faithfulness,
  it can be found as a welcome guest in many households across the world.
`;

class AmbSVJourneyListView extends Component {
    constructor(props) {
        super(props)
        let me = this
        this.mcityView = this.mcityView.bind(me)
        this.mcityItnsView = this.mcityItnsView.bind(me)
    }
/*
    getItnTrain(itns, svofferselectparent,o,reservekey, svr_fly  ){
        itns.map( (tn,idx)=>{
            return ( 
                <AmbItnSVPriceListView svofferselectparent={svofferselectparent}  itn={itn} svcustProfile={o.svcustProfile} reservekey={reservekey}  svrlocation={svr_fly}></AmbItnSVPriceListView>)
        })
    }
    */
    mcityItnsView(svfly_esquery_data,svofferselectparent, svofferMyFlyReservationSelectparent,priceInfo, svcustProfile, reservekey, legs){
        
        return legs.map( (itn, idx) =>{
               if(idx == 0){
                return (<AmbLocationSVPriceListView svfly_esquery_data={svfly_esquery_data} svofferMyFlyReservationSelectparent={svofferMyFlyReservationSelectparent} svofferselectparent={svofferselectparent}  priceInfo={priceInfo} svcustProfile={svcustProfile} reservekey={reservekey}  ></AmbLocationSVPriceListView>
                    )
               }else{
                return (<AmbItnSVPriceListView svfly_esquery_data={svfly_esquery_data} svofferMyFlyReservationSelectparent={svofferMyFlyReservationSelectparent} svofferselectparent={svofferselectparent}  svitn={itn} svcustProfile={svcustProfile} reservekey={reservekey}  ></AmbItnSVPriceListView>
                    )
               }
                

        })

    }

    mcityView(svfly_esquery_data,svofferselectparent,svofferMyFlyReservationSelectparent,priceInfo, svcustProfile, reservekey, legs){
        return(
            <div>
                {this.mcityItnsView(svfly_esquery_data,svofferselectparent,svofferMyFlyReservationSelectparent,priceInfo, svcustProfile, reservekey, legs)}
                 

            </div>
           
        )

    }

    render(){
        console.log('sv****Nob18 AmbsVJOurney ******************* ')
        const {svfly_esquery_data,svofferselectparent,svofferMyFlyReservationSelectparent,priceInfo,svcustProfile, reservekey } =this.props
    console.log(priceInfo)
     let offer = priceInfo.o
     console.log('sv****Nob18 priceInfo.o ', offer)
     let {itineraries} = offer
     let itn = null
    if(itineraries && (itineraries.length === 2)){
       
        itn = itineraries[1]
    }else if(itineraries && (itineraries.length > 2)){
        return this.mcityView(svfly_esquery_data,svofferselectparent,svofferMyFlyReservationSelectparent,priceInfo, svcustProfile, reservekey, itineraries)
    }else{
        console.log("itn is nul")
    }
   
    if(itn && (itn != null)){
        console.log('sv****Nob18 ROUNDTRIP  ')
        console.log(itn)
        
        return(
            <div>
                 <AmbLocationSVPriceListView svfly_esquery_data={svfly_esquery_data} svofferMyFlyReservationSelectparent={svofferMyFlyReservationSelectparent} svofferselectparent={svofferselectparent}  priceInfo={priceInfo} svcustProfile={svcustProfile} reservekey={reservekey}  ></AmbLocationSVPriceListView>
                 <AmbItnSVPriceListView svfly_esquery_data={svfly_esquery_data} svofferMyFlyReservationSelectparent={svofferMyFlyReservationSelectparent}  svofferselectparent={svofferselectparent}  svitn={itn} svcustProfile={svcustProfile} reservekey={reservekey}  ></AmbItnSVPriceListView>
                 
                 {/*  
                 <AmbItnSVPriceListView svofferselectparent={svofferselectparent}  itn={itn} svcustProfile={svcustProfile} reservekey={reservekey}  ></AmbItnSVPriceListView>
                 
                 */}
                 

            </div>
           
        )
    }else{
        console.log('sv****Nob18 ONWAY ')

        return(
           
            <AmbLocationSVPriceListView svfly_esquery_data={svfly_esquery_data} svofferMyFlyReservationSelectparent={svofferMyFlyReservationSelectparent} svofferselectparent={svofferselectparent}  priceInfo={priceInfo} svcustProfile={svcustProfile} reservekey={reservekey} ></AmbLocationSVPriceListView>
                

           
           
        )
    }

       
    }

}
export default AmbSVJourneyListView